import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, CoursesService } from '@draeger-academy/common';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { Course } from 'models/course';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { AcsInputComponent } from '../acs-input/acs-input.component';
import { FilterParameter } from 'models/filter-parameter';
import {Location} from '@angular/common'; 

@Component({
    selector: 'da-filtering',
    templateUrl: './filtering.component.html',
    styleUrls: ['./filtering.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FilteringComponent implements OnInit, OnChanges {
    @Input() showSecondLevelFiltering = false;
    @Input() hideFirstLevelFiltering = false;
    @Input() filterName = '';
    @Input() showThirdLevelFiltering = false;
    @Input() categories: any[];
    @Input() isUserPage: boolean;
    @Input() filterResetDone: boolean;
    @Input() parameterFromURL: FilterParameter;
    @Input() hasLoggedIn: boolean;
    // change data to use getter and setter
    @Input() saveFilteringParams = false;
    @Input() coursesByTitle: Course[];
    // tslint:disable-next-line:no-output-native
    @Output()
    change: EventEmitter<string> = new EventEmitter<string>();
    @Output()
    changeSubCat: EventEmitter<string> = new EventEmitter<string>();
    @Output()
    changeSubSubCat: EventEmitter<string> = new EventEmitter<string>();
    @Output()
    titleValue: EventEmitter<string> = new EventEmitter<string>();
    @Output()
    changeDivision: EventEmitter<string> = new EventEmitter<string>();
    @Input() hasCourses = false;
    @Input() showTitleSearch = true;
    public selectedValue = '';
    public selectedValueSubCat = '';
    public selectedValueSubSubCat = '';
    public allDataFatched = false;
    private _$translations: BehaviorSubject<any> = new BehaviorSubject({});
    public hasFocus = false;
    public hasFocusSubCat = false;
    public hasFocusSubSubCat = false;
    public hasFocusTitle = false;
    public title = '';
    public parameter: FilterParameter = {};
    public disablingBusinessField: boolean;
    private _subscriptionQueryParams: Subscription;
    private _$categories: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private _$showFiltering: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private _$parameterFromUrl: BehaviorSubject<any> = new BehaviorSubject<any>({});
    @ViewChild(AcsInputComponent) inputField: AcsInputComponent;
    public label;
    public labelNoValue;
    public firstCategory: any;

    public get categories$(): Observable<any> {
        return this._$categories.asObservable();
    }

    private _$subCategories: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    public get subCategories$(): Observable<any> {
        return this._$subCategories.asObservable();
    }

    private _$subSubCategories: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);

    public get subSubCategories$(): Observable<{}> {
        return this._$subSubCategories.asObservable();
    }

    public get showFiltering$(): Observable<boolean> {
        return this._$showFiltering.asObservable();
    }

    private _$disablingBusinessField: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public get disablingBusinessField$(): Observable<boolean> {
        return this._$disablingBusinessField.asObservable();
    }

    constructor(
        private activatedRoute: ActivatedRoute,
        public config: ConfigurationService,
        private _coursesService: CoursesService,
        private _translateService: TranslateService,
        private _router: Router,
        private _location: Location,
        private _authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.initFiltering();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['categories']) {
            setTimeout(() => {
                this._$categories.next(this.categories);
                this.initFiltering();
            }, 200);
        }
        if (changes['parameterFromURL']) {
            this._$parameterFromUrl.next(this.parameterFromURL);
        }

        if (changes['hasLoggedIn']) {
            if (this.hasLoggedIn) {
                this._$parameterFromUrl.next(null);
                this.parameter.division = null;
                this.selectedValue = null;
                setTimeout(() => {
                    this._$categories.next(this.categories);
                    this.initFiltering();
                }, 1000);
            }
        }
    }

    public initFiltering() {
        const _site = this.config.getCurrentSite();
        const currentPortal = this.config.portalId;
        const isPortal = this.config.isPartnerPage();
        if (this._$parameterFromUrl.getValue()?.division) {
            this.selectedValue = this._$parameterFromUrl.getValue().division;
        }
        this.bussinesFieldDisabled(isPortal);

        this.getLabelsForAllOrNothing();
        this.showFiltering();
        if (this._$parameterFromUrl.getValue()?.division) {
            if (this._$categories.getValue()) {
                if (this._$categories.getValue().length > 1) {
                    this._$categories.getValue().filter((data) => {
                        if (data.id === this._$parameterFromUrl.getValue()?.division) {
                            this.onSelect(data.id, false);
                            this.selectedValue = data.id;
                        }
                    });
                } else {
                    this._$categories.getValue().filter((data) => {
                        this.onSelect(this._$categories.getValue()[0].id, false);
                        this.selectedValue = this._$categories.getValue()[0].id;
                    });
                }
            }
            this.initFilters(_site);
        } else {
            if (isPortal) {
                this.initFilters(currentPortal);
            } else {
                this.initFilters(_site);
            }
        }
    }

    public showFiltering() {
        const isPortal = this.config.isPartnerPage();

        if (!isPortal) {
            this._$showFiltering.next(this.config.hasFeature('SearchBy'));
        } else {
            this.config.getConfigPartnerByPortal().then((values) => {
                if (values) {
                    const tempFeatures = values.filter((setting) => setting.key.toLowerCase() === 'features');
                    let hasCheckPrerequest;
                    if (tempFeatures && tempFeatures[0] && tempFeatures[0].value && tempFeatures[0].value.length > 0) {
                        hasCheckPrerequest = tempFeatures[0].value.filter((setting) => setting.name === 'SearchBy');
                    }
                    if (hasCheckPrerequest && hasCheckPrerequest[0] && hasCheckPrerequest[0].enabled) {
                        this._$showFiltering.next(true);
                    }
                }
            });
        }
    }

    public valuechange(valueTyped) {
        this.titleValue.emit(valueTyped);
    }

    initFilters(_site) {
        if (this.selectedValue) {
            if (this.selectedValue === '0' && this._$categories.getValue()[0]) {
                this.selectedValue = this._$categories.getValue()[0].id;
                this.onSelect(this._$categories.getValue()[0].id, false);
            }
        }
        else {
            if (this._$categories.getValue() && this._$categories.getValue()[0]) {
                this.selectedValue = this._$categories.getValue()[0].id;
                this.onSelect(this.selectedValue, false);
            }
        }
        if (
            !this.selectedValueSubCat ||
            this.selectedValueSubCat === 'null'
        ) {
            this.selectedValueSubCat = this.label;
        }
        if (
            !this.selectedValueSubSubCat ||
            this.selectedValueSubSubCat === 'null'
        ) {
            this.selectedValueSubSubCat = this.label;
        }
        if (this._$categories.getValue() && this._$categories.getValue().length === 1) {
            const _onlyCategoryID = this._$categories.getValue()[0].id;
            this.selectedValue = _onlyCategoryID;
            this.onSelect(_onlyCategoryID, true);
            if (this._$parameterFromUrl.getValue()?.trainingsSegment === null && this.selectedValue !== _onlyCategoryID ) {
                this.selectedValueSubCat = this.label;
            } else  if (this._$parameterFromUrl.getValue()?.trainingsSegment !== null && this.selectedValue !== _onlyCategoryID){
                this.selectedValueSubCat = this._$parameterFromUrl.getValue()?.trainingsSegment;
            }
            this.parameter.division = this._$categories.getValue()[0].id;
            this.parameter.trainingsSegment = this.selectedValueSubCat;
            this.parameter.productArea = this.selectedValueSubSubCat;

            if (this.selectedValueSubCat === this.label || this.selectedValueSubCat === this.labelNoValue) {
                this.parameter.trainingsSegment = null;
            }
            if (this.selectedValueSubSubCat === this.label || this.selectedValueSubSubCat === this.labelNoValue) {
                this.parameter.productArea = null;
            }
            this.putOtherSelectedFilterIntoParameter();
            this.addParamsToUrl(this.parameter);
        } else if (this._$categories.getValue()?.length > 1 && this._$parameterFromUrl.getValue()?.division === null) {
           this.onSelect(this.selectedValue, true); // Alle
        } else if (this._$categories.getValue()?.length > 1 && !!this._$parameterFromUrl.getValue()?.division) {
            this.selectedValue = this._$parameterFromUrl.getValue().division;
            if (!!this._$parameterFromUrl.getValue().trainingsSegment && !!this._$parameterFromUrl.getValue().productArea) {
                this.selectedValueSubCat = this._$parameterFromUrl.getValue().trainingsSegment;
                this.selectedValueSubSubCat = this._$parameterFromUrl.getValue().productArea;
            } else if (!!this._$parameterFromUrl.getValue().trainingsSegment && !this._$parameterFromUrl.getValue().productArea) {
                this.selectedValueSubCat = this._$parameterFromUrl.getValue().trainingsSegment;
                this.selectedValueSubSubCat = this.label;
                if (this._$subSubCategories.getValue()[0].name === this.labelNoValue) {
                    this.selectedValueSubSubCat = this.labelNoValue;
                }
            } else if (!this._$parameterFromUrl.getValue().trainingsSegment && !this._$parameterFromUrl.getValue().productArea) {
                this.selectedValueSubCat = this.label;
                const _subCategories = this._$subCategories.getValue();
                if (_subCategories.length === 1 && _subCategories[0].name === this.labelNoValue) {
                    this.selectedValueSubCat = this.labelNoValue;
                }
                this.selectedValueSubSubCat = this.labelNoValue;
            }
        }
    }

    public reset() {
        this.selectedValueSubCat = this.labelNoValue;
        this.selectedValueSubSubCat = this.labelNoValue;
        this.selectedValue = this._$categories.getValue()[0].id;
        this.inputField?.reset();
        this._$parameterFromUrl.next(null);
        this.setSubCats(this.selectedValue);
    }

    public hasValue(fieldname) {
        return fieldname ? fieldname.toString() !== '' : false;
    }

    onSelect(categoryId: string, reset: boolean) {
        this.change.emit(categoryId);
        this.setSubCats(categoryId);
        this.setSubSubCats();
    }

    setSubCats(categoryId) {
        const newFirstElement = { id: 0, name: this.label };
        const noValueElement = { id: 0, name: this.labelNoValue };
        let category;
        if (this._$categories.getValue() ) {
            if (categoryId === 0 || categoryId === '0' || this._$categories.getValue().length === 0) {
                this._$subCategories.next([noValueElement]);
                this._$subSubCategories.next([noValueElement]);
                this.selectedValueSubCat = this.labelNoValue;
                this.selectedValueSubSubCat = this.labelNoValue;
            }
            if (this._$categories.getValue()[0]?.id === 0) {
                for (let i = 1; i <= this._$categories.getValue().length - 1; i++) {
                    if (categoryId ===  this._$categories.getValue()[i].id) {
                        category = this._$categories.getValue()[i];
                        if (category && category.childCategories && category.childCategories.length > 0) {
                            const filteredCategories = [newFirstElement].concat(category.childCategories);
                            this._$subCategories.next([...filteredCategories]);
                            this._$subSubCategories.next([newFirstElement]);
                            this.selectedValueSubCat = newFirstElement.name;
                            if (this._$parameterFromUrl.getValue()?.trainingsSegment) {
                                category.childCategories.forEach((cat) => {
                                    if (cat.name === this._$parameterFromUrl.getValue()?.trainingsSegment) {
                                        this.selectedValueSubCat = this._$parameterFromUrl.getValue().trainingsSegment;
                                        if (this._$parameterFromUrl.getValue()?.productArea === undefined && this._$subSubCategories.getValue()[0].length > 1) {
                                             this.selectedValueSubSubCat = this.label;
                                        } else if (this._$subSubCategories.getValue()[0].name === this.labelNoValue) {
                                            this.selectedValueSubSubCat = this.labelNoValue;
                                        }
                                    }
                                });
                            }
                        } else {
                            this._$subCategories.next([noValueElement]);
                            this._$subSubCategories.next([noValueElement]);
                            this.selectedValueSubCat = this.labelNoValue;
                            this.selectedValueSubSubCat = this.labelNoValue;
                        }
                    }
                } 
            } else {
                    if (categoryId ===  this._$categories.getValue()[0]?.id) {
                        category = this._$categories.getValue()[0];
                        if (category && category.childCategories && category.childCategories.length > 0) {
                            const filteredCategories = [newFirstElement].concat(category.childCategories);
                            this._$subCategories.next([...filteredCategories]);
                            this._$subSubCategories.next([newFirstElement]);
                            this.selectedValueSubCat = newFirstElement.name;
                            if (this._$parameterFromUrl.getValue()?.trainingsSegment) {
                                category.childCategories.forEach((cat) => {
                                    if (cat.name === this._$parameterFromUrl.getValue()?.trainingsSegment) {
                                        this.selectedValueSubCat = this._$parameterFromUrl.getValue().trainingsSegment;
                                    }
                                });
                            }
                            this._$subSubCategories.next([noValueElement]);
                            this.selectedValueSubSubCat = this.labelNoValue;
                        } else {
                            this._$subCategories.next([noValueElement]);
                            this._$subSubCategories.next([noValueElement]);
                            this.selectedValueSubCat = this.labelNoValue;
                            this.selectedValueSubSubCat = this.labelNoValue;
                        }
                    }
            }
        }
    }

    onSelectSubCat(categoryId: string, reset: boolean) {
        this.changeSubCat.emit(categoryId);

        if (this._$categories.getValue().length === 1) {
            this.parameter.division = this._$categories.getValue()[0].id;
        } else {
            this.parameter.division = this.selectedValue;
        }
        if (categoryId === this.label) {
            this.parameter.trainingsSegment = null;
        } else {
            this.parameter.trainingsSegment = categoryId;
        }
        this.parameter.productArea = null;
        this.selectedValueSubSubCat = this.label;
        this.putOtherSelectedFilterIntoParameter();
        this.addParamsToUrl(this.parameter);
        this.setSubSubCats();
    }

    setSubSubCats() {
        const newFirstElement = { id: this.label, name: this.label };
        const noValueElement = { id: 0, name: this.labelNoValue };
        let cats;
        let subCats;
        if (this._$categories.getValue()) {
            cats = this._$categories.getValue().filter((f) => f.id === this.selectedValue)[0];
            if (cats && cats.childCategories) {
                subCats = cats.childCategories.filter((f) => f.name === this.selectedValueSubCat)[0];
                if (subCats && subCats.childCategories && subCats.childCategories.length > 0) {
                    const filteredCategories = [newFirstElement].concat(subCats.childCategories);
                    this._$subSubCategories.next([...filteredCategories]);
                    this.selectedValueSubSubCat = newFirstElement.name;
                    if (this._$parameterFromUrl.getValue()?.productArea) {
                        subCats.childCategories.forEach((cat) => {
                            if (cat.name === this._$parameterFromUrl.getValue()?.productArea) {
                                this.selectedValueSubSubCat = this._$parameterFromUrl.getValue().productArea;
                            }
                        });
                    }
                } else {
                    if (this.selectedValueSubCat === this.labelNoValue || this.selectedValueSubCat === this.label || subCats.childCategories.length === 0) {
                        this._$subSubCategories.next([noValueElement]);
                        this.selectedValueSubSubCat = this.labelNoValue;
                    } else {
                        this._$subSubCategories.next([newFirstElement]);
                        this.selectedValueSubSubCat = this.label;
                    }
                }
            }
        }
    }

    onSelectSubSubCat(categoryId: string) {
        this.changeSubSubCat.emit(categoryId);
        if (this._$categories.getValue().length === 1) {
            this.parameter.division = this._$categories.getValue()[0].id;
        } else {
            this.parameter.division = this.selectedValue;
        }
        if (categoryId === this.label) {
            this.parameter.productArea = null;
        } else {
            this.parameter.productArea = categoryId;
        }
        this.parameter.trainingsSegment = this.selectedValueSubCat;
        this.putOtherSelectedFilterIntoParameter();
        this.addParamsToUrl(this.parameter);
    }

    public getLabelsForAllOrNothing() {
        this._translateService.stream('common').subscribe((data) => {
            if (data) {
                this._$translations.next(data);
                if (this._$translations.getValue().filteringDropdownAll) {
                    this.label = this._$translations.getValue().filteringDropdownAll;
                } else {
                    this.label = 'All';
                }
                if (this._$translations.getValue().filteringDropdownNoSelection) {
                    this.labelNoValue = this._$translations.getValue().filteringDropdownNoSelection;
                } else {
                    this.labelNoValue = 'No selected value';
                }
                if (this._$translations.getValue().filteringDropdownAll) {
                    let categoryId = '0';                   
                    if (this.selectedValue) {
                        categoryId = this.selectedValue;
                    }
                    this.setSubCats(categoryId);
                    this.setSubSubCats();
                }
            }
        });
    }

    public bussinesFieldDisabled(isPortal) {
        if (this._$categories.getValue()) {
            if (this._$categories.getValue().length === 1) {
                this._$disablingBusinessField.next(true);
            } else {
                this._$disablingBusinessField.next(false);
            }
        }
    }
    public onSelectDivisions(value, reset) {
        this.selectedValueSubCat = null;
        this.selectedValueSubSubCat = null;
        this.addParameterToUrl(value);
        this.onSelect(value, reset);
        this.changeDivision.emit(value);
    }
    public addParameterToUrl(value) {

        this.parameter.division = value;
        if (value === '0' || value === 0 ) {
            this.parameter.division = null;
        }
        this.parameter.trainingsSegment = null;
        this.parameter.productArea = null;
        this.putOtherSelectedFilterIntoParameter()
        this.addParamsToUrl(this.parameter);
    }
    private addParamsToUrl(parameters) {
         this.changeParameterNamesToKeys(parameters);
        const URL = this._router.createUrlTree([], {relativeTo: this.activatedRoute, queryParams: parameters}).toString();
        this._location.go(URL)
    }

    private putOtherSelectedFilterIntoParameter() {
        this.parameter.city = !!this._$parameterFromUrl.getValue()?.city ? this._$parameterFromUrl.getValue().city : null;
        this.parameter.month = !!this._$parameterFromUrl.getValue()?.month ? this._$parameterFromUrl.getValue().month : null;
        this.parameter.year = !!this._$parameterFromUrl.getValue()?.year ? this._$parameterFromUrl.getValue().year : null;
        this.parameter.title = !!this._$parameterFromUrl.getValue()?.title ? this._$parameterFromUrl.getValue().title : null;
        this.parameter.isVirtual = this._$parameterFromUrl.getValue()?.isVirtual;
        this.parameter.isPresence = this._$parameterFromUrl.getValue()?.isPresence;
        this.parameter.isWBT = this._$parameterFromUrl.getValue()?.isWBT;
        this.parameter.toggleFilter = this._$parameterFromUrl.getValue()?.toggleFilter;
        this._$parameterFromUrl.next(this.parameter);
    }

    private changeParameterNamesToKeys(parameters) {
        // find trainingsSegment key in category Call
        if (!!parameters.trainingsSegment) {
            this._$categories.getValue().forEach((cat) => {
                cat.childCategories?.forEach((subCat) => {
                    if (subCat.name === parameters.trainingsSegment) {
                        parameters.trainingsSegment = subCat.id;
                    }
                });
            });
        }
       
        // find productArea key in category Call
        if (!!parameters.productArea) {
            this._$categories.getValue().forEach((cat) => {
                cat.childCategories?.forEach((subCat) => {
                    subCat.childCategories?.forEach((subSubCat) => {
                        if (subSubCat.name === parameters.productArea) {
                            parameters.productArea = subSubCat.id;
                        }
                    });
                });
            });
        }
        return parameters;
    }
}
